import api from "../../api";
import { get, rem, set } from "../../storage/storage";
import { setToken } from "../../api";

export const types = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  VERIFY: "VERIFY",
  RESET: "RESET",
  FORGOT: "FORGOT"
};

export const actions = {
  [types.LOGIN]: async ({ commit }, { login, password }) => {
    try {
      const { data } = await api.npost("/auth/login", { login, password });
      set("token", data.api_token);
      setToken(data.api_token);
      commit("setToken", data.api_token);
    } catch (e) {
      throw e;
    }
  },
  [types.LOGOUT]: ({ commit }, router) => {
    rem("token");
    commit("setToken", "");
    if (router) router.push("/auth/login");
  },
  [types.FORGOT]: async (_, user) => {
    try {
      await api.npost("/auth/forgot", user);
    } catch (e) {
      throw e;
    }
  },
  [types.RESET]: async (_, user) => {
    try {
      await api.npost("/auth/reset", user);
    } catch (e) {
      throw e;
    }
  },
  [types.VERIFY]: async ({ commit }) => {
    const t = get("token");
    if (!t) throw new Error();
    try {
      const { data } = await api.npost("/auth/verify", { api_token: t });
      set("token", data.api_token);
      commit("setToken", data.api_token);
      return true;
    } catch (e) {
      rem("token");
      throw e;
    }
  }
};
